import { config } from '../config'
import { getPlayStoreUrl } from './playStoreUrl.js'
import { trackGooglePlayGoal } from './trackGooglePlayGoal.js'

import { analytics } from '@/firebase.js';
import { logEvent } from 'firebase/analytics';

export const openApp = () => {
    logEvent(analytics, 'chrome');
    
    console.log('analytics activate');
    const isAndroid = /Android/i.test(navigator.userAgent);
    if (isAndroid) {
        trackGooglePlayGoal();
    } else if (typeof ym === 'function') {
        ym(config.yandexMetrikaId,'reachGoal','chrome')
    }
    const url = isAndroid 
            ? getPlayStoreUrl()
            : 'https://chromewebstore.google.com/detail/myvpn-proxy/lmkinhmkdpccgkhdhfmbpademifljdob?hl=ru&utm_source=ext_sidebar';
    if (isAndroid) {
        window.location.assign(url);
        return;
    }
    window.open(url, '_blank');
}
